import React from "react";
import {QuickLists} from "./WorkListQuickList";
import {useGetTransQuickListSettings} from "./quickListSettings";
import {useAuth} from "../../context/authContext";
import {QuickListContext} from "./QuickListContext";

const WorkListv2 = () => {
  const auth = useAuth();
  const getSettingsRefScheduled = useGetTransQuickListSettings("workList2", 0, auth);

  return (
      <>
        <QuickListContext.Provider value={getSettingsRefScheduled()}>
            <QuickLists {...getSettingsRefScheduled()} />
        </QuickListContext.Provider>
      </>
  );
};

export { WorkListv2 };
